var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser1Regular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 23C1.01844 21.4291 1.34548 19.8771 1.9625 18.4322C2.63625 17.0834 5.45362 16.1484 8.99012 14.8394C9.95262 14.4846 9.789 11.9876 9.3655 11.5215C8.68985 10.7914 8.17638 9.92655 7.85882 8.98383C7.54126 8.04111 7.42681 7.04186 7.523 6.05175C7.46239 5.42138 7.53225 4.78529 7.72824 4.1831C7.92423 3.58092 8.24214 3.02555 8.66216 2.55161C9.08218 2.07766 9.59531 1.69531 10.1696 1.42836C10.7438 1.16141 11.3669 1.0156 12 1C12.6331 1.0156 13.2562 1.16141 13.8304 1.42836C14.4047 1.69531 14.9178 2.07766 15.3378 2.55161C15.7579 3.02555 16.0758 3.58092 16.2718 4.1831C16.4677 4.78529 16.5376 5.42138 16.477 6.05175C16.5735 7.04101 16.4597 8.03951 16.1432 8.9817C15.8266 9.9239 15.3143 10.7885 14.64 11.5187C14.2165 11.9849 14.0597 14.4819 15.0154 14.8366C18.5519 16.1456 21.3693 17.0806 22.043 18.4295C22.6585 19.8755 22.9837 21.4285 23 23H1Z",
    stroke: "current",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser1Regular);
export default __webpack_public_path__ + "static/media/user1-regular.5ce8d65cf099900c3be5d0680a374be8.svg";
export { ForwardRef as ReactComponent };